module.exports = __webpack_public_path__ + "img/tera_rewards.90610b01.svg";